import {
  isPhoneSelector,
  isEcommerceSearchBarEnabled,
} from './configSelectors';

export const isAdvancedFilterOpen = state => state.filter.isAdvancedFilterOpen;

export const isDesktopAndAdvancedFilterOpen = state => (
  !isPhoneSelector(state)
  && isAdvancedFilterOpen(state)
  && isEcommerceSearchBarEnabled(state)
);



// WEBPACK FOOTER //
// ./src/selectors/filter_selector.js